import React, { FC, useContext } from 'react';
import { DocumentProvider } from 'components/organisms/document/document-store';
import { SquadProvider } from 'contexts/providers/squad';
import { TaskFieldsProvider } from 'contexts/providers/task-fields';
import { TaskPaneContextProvider } from 'contexts/providers/task-pane';
import { EditorDataContext } from '../editor-data/editor-data-store';
import { DocumentTasksSectionBase } from './tasks-section';

interface DocTaskPropsOnly {
  documentId: number;
  projectId: number;
}

type DocTaskProps = JSX.IntrinsicAttributes & DocTaskPropsOnly;

export interface DocTaskSectionProps extends DocTaskProps {
  resourceSectionId: number;
}

export const DocumentTasksSection: FC<DocTaskSectionProps> = (props) => {
  const { projectId, resourceSectionId } = props;

  const editorData = useContext(EditorDataContext);

  return (
    <TaskPaneContextProvider>
      <DocumentProvider>
        <SquadProvider projectId={projectId}>
          <TaskFieldsProvider>
            <DocumentTasksSectionBase
              resourceSectionId={resourceSectionId}
              editorData={editorData}
            />
          </TaskFieldsProvider>
        </SquadProvider>
      </DocumentProvider>
    </TaskPaneContextProvider>
  );
};
